import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  CircularProgress
} from '@mui/material'
import MultiValue from './base/multi-value';
import { useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const Consents = (props) => {
  const [consentaccordian, setConsentaccordian] = useState(true)
  const {consentProgressBar, consentKeys, consentData } = props

  const closeConsentAccordian = prev => {
    setConsentaccordian(!prev)
  }

  return (
    <>
      <Accordion square className='shadow-none' expanded={consentaccordian}>
        <AccordionSummary
          onClick={() => {
            closeConsentAccordian(consentaccordian)
          }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls='panel1a-content'
          id='consentInformartion'
          className='bg-grey'
        >
          <Typography
            variant='subtitle1'
            className='fw-bold _wg-dynamic-text mr-5'
          >
            Consents
          </Typography>
          { consentProgressBar && (
            <CircularProgress
              sx={{ color: '#ce2a1d', marginLeft: 'auto', marginBlock: 'auto' }}
              size={20}
            />
          )}
        </AccordionSummary>
        <AccordionDetails className='border row container p-1 ms-1'>
          {Object.values(consentData)?.map((e, key) => {
            return (
              <div
                className={
                  consentKeys[key] == 'Channel_Consents' ? 'col-12' : 'col-6'
                }
                key={key}
              >
                <MultiValue
                  label={consentKeys[key].replace('_', ' ')}
                  key={key}
                  heading={
                    consentKeys[key] == 'Preferences'
                      ? 'PreferenceCategory'
                      : 'ConsentType'
                  }
                  value={e ? e : []}
                  noSearch={true}
                  subhead={'consents'}
                />
              </div>
            )
          })}
          {Object.keys(consentData).length == 0 &&
            <em className="pt-2 pb-2 _wg-dynamic-text">No data found</em>
          }
        </AccordionDetails>
      </Accordion>
    </>
  )
}

export default Consents
